
  import ImageLoader from "@/assets/scripts/ImageLoader";
  import HeaderLayout from "@/components/layouts/Header.vue";
  import FooterLayout from "@/components/layouts/Footer.vue";
  import TripleBlock from "@/components/blocks/Triple.vue";
  import PriceTag from "@/components/priceTag/PriceTag.vue";

  export default {
    name: "WebsitesView",
    components: {
      HeaderLayout,
      FooterLayout,
      TripleBlock,
      PriceTag,
    },
    data() {
      return {
        websitesImage: ImageLoader.loadImageSrc("assets/images/decorators/statische_website.jpg"),
      };
    },
  };
